import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import TopBar from 'components/top-bar';
import IndexPage from 'pages/index';
import ApplicationPage from 'pages/application';
import Regist from 'pages/regist';
import ApplicationList from 'pages/application-list';
import OAuth from 'pages/oauth';
import Footer from 'components/footer';
import SystemNotice from 'components/system-notice';
import WechatOAuth from 'pages/wechat-oauth';
import Rta from 'pages/rta';
import ManageLayout from './pages/manage/layout';
// @ts-ignore
import LoginPortal from './pages/loginPortal';
// @ts-ignore
import OrderStore from 'pages/orderDialog';

import '../assets/style/common.scss';

// 系统公告开关：为 true 时整站替换为公告页，关闭时设为 false 即可恢复
const SYSTEM_NOTICE_ON = true;

const App = () => {
  const { pathname } = useLocation();

  if (SYSTEM_NOTICE_ON) {
    return (
      <>
        <TopBar mode="dark" minimal />
        <SystemNotice />
      </>
    );
  }

  const exclude = ['/oauth', '/wechat-oauth', '/login/portal'].includes(pathname);
  const noFooter = ['/manage'].some((url) => pathname.indexOf(url) > -1);

  return (
    <>
      {!exclude && <TopBar mode={pathname === '/' ? 'light' : 'dark'} />}

      <Switch>
        <Route path="/application/rta">
          <Rta />
        </Route>
        <Route path="/application/:id">
          <ApplicationPage />
        </Route>
        <Route path="/application-list">
          <ApplicationList />
        </Route>
        <Route path="/oauth">
          <OAuth />
        </Route>
        <Route path="/wechat-oauth">
          <WechatOAuth />
        </Route>
        <Route path="/regist">
          <Regist />
        </Route>
        <Route path="/manage">
          <ManageLayout />
        </Route>
        <Route exact path="/login/portal">
          <LoginPortal />
        </Route>
        <Route exact path="/">
          <IndexPage />
        </Route>
        <Route path="*">
          <div
            style={{
              marginTop: 24,
              marginLeft: 32,
            }}
          >
            404 not found
          </div>
        </Route>
      </Switch>

      <OrderStore />
      {!(exclude || noFooter) && <Footer />}
    </>
  );
};

export default App;
